import BacktestTable from '../components/BacktestTable';

// Historical simulation results for the cheap-bot ignition trigger
// (backend: cmd/cheapbacktest, served read-only at /api/cheap-backtest).
// Split out from the Bot page 2026-07-11 so the live paper-trading widgets
// and the static backtest data aren't mixed on the same screen. Admin-only.
export default function BotTest() {
  return (
    <div>
      <BacktestTable
        variant="spy"
        title="Backtest (SPY) — 2026-06-22 → 2026-07-11"
        subtitle="Historical simulation of the exact bot rules over the last 3 weeks (1-min bars): entry cap $0.15, 3 contracts, one trade at a time, TP +100%, market sell after 30 min, last entry 3:00 PM ET, $500 budget / $50 stop floor / profits above $500 saved. Retuned 2026-07-11: trigger 1.5x + 3-tick minimum bounce + 5x volume spike (the original 1.4x/3x combo netted -$78; retuned: +$51). Bars carry no bid/ask, so entries are at last-trade (slightly optimistic vs paying the ask)."
      />
      <BacktestTable
        variant="spx"
        title="Backtest (SPX) — 2026-06-22 → 2026-07-11"
        subtitle="Same simulation at SPX scale: entry cap $0.25, last entry 3:30 PM ET, otherwise identical rules and the same bar-data approximations. Retuned 2026-07-11: trigger 1.5x + 3-tick minimum bounce + 5x volume spike (the original 1.4x/3x/$0.80 combo lost $450 and hit the budget floor in 4 days)."
      />
    </div>
  );
}
